import { fromJS } from 'immutable';
import {
  receivingEntities,
  receivedEntities,
  updateAffiliates,
} from './entities';
import { prophotoFetch } from '../lib/fetch';


export function fetchAffiliateData() {
  return async dispatch => {
    dispatch(receivingEntities('pp_affiliates'));
    const res = await prophotoFetch(`${process.env.REACT_APP_PP_API_URL}/affiliate-codes`);
    const json = await res.json();
    dispatch(updateAffiliates(fromJS(json)));
    dispatch(receivedEntities('pp_affiliates'));
  }
}
  